var map = {
	"./blog.yml": 105,
	"./cloud.yml": 106,
	"./color.yml": 107,
	"./country.yml": 108,
	"./dio.yml": 109,
	"./doc.yml": 110,
	"./emoji.yml": 111,
	"./flag.yml": 112,
	"./git.yml": 113,
	"./icon.yml": 114,
	"./license.yml": 115,
	"./link.yml": 116,
	"./metrics.yml": 117,
	"./people.yml": 118,
	"./soft.yml": 119,
	"./src.yml": 120,
	"./status.yml": 121,
	"./taxonomy.yml": 122
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 104;